import { styled } from 'styled-components'

export const HorizontalScrollbar = styled.div<{
    $hasOverflow?: boolean
    $showActionButtons?: boolean
}>`
    display: grid;
    padding: 0 2px;
    gap: 4px;
    grid-auto-flow: row;
    grid-template: 1fr / ${(p) =>
            p.$showActionButtons ? 'auto 1fr auto' : '1fr'};
    //padding: 1rem;
    place-items: center;

    opacity: ${(p) => (p.$hasOverflow ? '1' : '0')};
`

export const HorizontalTrackAndThumb = styled.div<{ $scrollbarWidth: number }>`
    display: block;
    width: 100%;
    position: relative;
    height: ${(p) => p.$scrollbarWidth}px;
    border-radius: ${(p) => Math.floor(p.$scrollbarWidth) / 2}px;

    background-color: ${(p) => p.theme.colors.lighterGrey};
`

export const HorizontalTrack = styled.div<{
    $scrollbarWidth: number
    $isDragging?: boolean
}>`
    left: 0;
    right: 0;
    cursor: ${(p) => (p.$isDragging ? 'grabbing' : undefined)};
    position: absolute;
    height: ${(p) => p.$scrollbarWidth}px;
    border-radius: ${(p) => Math.floor(p.$scrollbarWidth) / 2}px;
`

export const HorizontalThumb = styled.div<{
    $width: number
    $scrollbarWidth: number
    $isDragging?: boolean
}>`
    position: absolute;
    width: ${(p) => `${p.$width}px`};
    cursor: ${(p) => (p.$isDragging ? 'grabbing' : 'grab')};

    height: ${(p) => p.$scrollbarWidth}px;
    border-radius: ${(p) => Math.floor(p.$scrollbarWidth / 2)}px;
    background-color: ${(p) => p.theme.colors.primaryGreen};
`
